import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const OmOss = lazy(() => import("@/pages/info/OmOss"));

export const Route = createFileRoute("/om-oss")({
  head: () => seoHead("/om-oss", { description: "Elmarknad är en jämförelsetjänst inom el och energi. Vi hjälper svenska hushåll och företag att jämföra elavtal från alla Sveriges elbolag och att få offerter på solceller, batterier, värmepumpar och elbilsladdare." }),
  component: () => <OmOss />,
});
